
<template>
  <div v-if="new_task.to_user_or_department == 'department' " style="border-radius: 5px; border: 1px solid #ccc" class="mb-3" >
    <div class="font-weight-bold pb-1 pt-2 pl-2">
      Selecione os departamentos
    </div>
    <div class="pb-1 pl-6">
      Todos usuários dos selecionados, incluindo os respectivos subdepartamentos, poderão realizar este agendamento.
    </div>
    <v-treeview
      v-if="dep_items.length>0"
      v-model="new_task.department_ids"
      :items="dep_items"
      dense
      selectable
      selected-color="light-green accent-4"
      hoverable
      color="secondary"
      shaped
      ref="treeDepto"
      selection-type="independent"
    >
      <template v-slot:prepend="{ item, open }">
        <v-icon small class="ml-2">{{ open ? 'mdi-folder-open' : item.children.length? 'mdi-folder' : 'mdi-tag' }}</v-icon>
      </template>
      <template v-slot:label="{ item, open, active }">
        <span>{{item.name}}</span>
      </template>
    </v-treeview>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api'

export default {
  name: '',
  props: {
    new_task: {
      type: Object,
    },
  },
  data() {
    return {
      dep_items: [],
    }
  },
  mounted () {
    this.getAllDepartments();
  },
  methods: {
    getAllDepartments() {
      Api.Department.index().then(response => response.data).then(deps => {
        this.dep_items = !deps[0][0].ancestry
          ? [...deps[0][0].children]
          : [...deps.map(d => d[0])];
      });
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    },
    'new_task.frequency_option'(nv,ov) {
      if (nv){
        nv.action()
      } else if (nv == false){
    
      }
    }
  },
}
</script>

<style scoped>

</style>